const WHITE_TEXT = '#ffffff';

const SERVICE_TAG_COLORS = {
  'Dynamics 365 Apps': ['#002050', WHITE_TEXT],
  'Exchange Online': ['#0078d4', WHITE_TEXT],
  'Microsoft 365 Copilot Chat': ['#464feb', WHITE_TEXT],
  'Microsoft 365 apps': ['#d83b01', WHITE_TEXT],
  'Microsoft 365 for the web': ['#d83b01', WHITE_TEXT],
  'Microsoft 365 suite': ['#d83b01', WHITE_TEXT],
  'Microsoft Bookings': ['#008272', WHITE_TEXT],
  'Microsoft Clipchamp': ['#c43eae', WHITE_TEXT],
  'Microsoft Copilot (Microsoft 365)': ['#464feb', WHITE_TEXT],
  'Microsoft Copilot (Power Platform)': ['#742774', WHITE_TEXT],
  'Microsoft Dataverse': ['#087f5b', WHITE_TEXT],
  'Microsoft Defender XDR': ['#0078d4', WHITE_TEXT],
  'Microsoft Entra': ['#66ddff', '#242424'],
  'Microsoft Forms': ['#107c10', WHITE_TEXT],
  'Microsoft Intune': ['#0078d4', WHITE_TEXT],
  'Microsoft OneDrive': ['#0078d4', WHITE_TEXT],
  'Microsoft Power Automate': ['#0066ff', WHITE_TEXT],
  'Microsoft Power Automate in Microsoft 365': ['#0066ff', WHITE_TEXT],
  'Microsoft Purview': ['#008272', WHITE_TEXT],
  'Microsoft Teams': ['#5b5fc7', WHITE_TEXT],
  'Microsoft Viva': ['#744da9', WHITE_TEXT],
  Planner: ['#31752f', WHITE_TEXT],
  'Power Apps': ['#742774', WHITE_TEXT],
  'Power BI': ['#f2c811', '#242424'],
  'Power Platform': ['#742774', WHITE_TEXT],
  'SharePoint Online': ['#007e8a', WHITE_TEXT],
  Sway: ['#008272', WHITE_TEXT],
};

const FALLBACK_COLORS = ['#4b5563', WHITE_TEXT];

export function getServiceTagStyle(service) {
  const [backgroundColor, color] = SERVICE_TAG_COLORS[service?.trim()] ?? FALLBACK_COLORS;

  return {
    backgroundColor,
    borderColor: backgroundColor,
    color,
  };
}
